/**
 * The report screens' constants (ADR 9063): «My reports», which anyone signed in may open, and the
 * triage screen, which only the delivery team may.
 *
 * In a file of its own, as the admin screens' constants are, so the router, the palette, the rails
 * and the report form agree about the paths without importing the screens and their reads.
 */

import type { RouteRequires } from '../../../features/manifest';

/** What the signed-in person has reported, and the team's answer. */
export const FEEDBACK_PATH = '/me/feedback';

/** Every report, for the delivery team to triage. */
export const FEEDBACK_TRIAGE_PATH = '/feedback/triage';

/** The realm role that opens the triage screen and its reads; held by the delivery team only. */
export const FEEDBACK_TRIAGE_ROLE = 'feedback_triage';

/** The triage route's `requires`, in the manifest's own type, read by `RequiresGate`. */
export const FEEDBACK_TRIAGE_REQUIRES: RouteRequires = [FEEDBACK_TRIAGE_ROLE];

/**
 * The statuses in which a report is closed (bata-platform ADR 1020): its author can no longer
 * reply, and only the team can reopen it. Everything else — `in_progress` included — is open.
 */
export const CLOSED_STATUSES: ReadonlySet<string> = new Set(['delivered', 'resolved', 'declined']);
